
import React from "react";
import MapPage from "./MapPage";
import ContactSection from "./ContactSection";
import "./ContactSection.css";
import { Helmet } from "react-helmet";

const seo = {
  title: "יצירת קשר עם עו״ד רז יוסף | משרד עורכי דין בנתניה",
  description:
    "צרו קשר עם משרד עורכי הדין רז יוסף בנתניה לקבלת ייעוץ וייצוג משפטי בתחומי דיני המשפחה, גירושין, מזונות, אחריות הורית וזמני שהות, חלוקת רכוש, הסכמי ממון, צוואות וירושות. למעלה מ-24 שנות ניסיון משפטי.",
  url: "https://razfamilylaw.co.il/ContactSection2",
  image: "https://razfamilylaw.co.il/logo192.png"
};

const legalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "LegalService",
  name: "רז יוסף – משרד עורכי דין",
  url: "https://razfamilylaw.co.il/",
  image: seo.image,
  telephone: "+972507575775",
  email: "raz290174@gmail.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "רחוב האורזים 23",
    addressLocality: "נתניה",
    addressCountry: "IL"
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday"
      ],
      opens: "09:00",
      closes: "17:00"
    }
  ],
  areaServed: {
    "@type": "Country",
    name: "ישראל"
  },
  knowsAbout: [
    "דיני משפחה",
    "גירושין",
    "הסכמי גירושין וגישור",
    "אחריות הורית",
    "זמני שהות",
    "מזונות ילדים",
    "מזונות אישה",
    "חלוקת רכוש",
    "איזון משאבים",
    "הסכמי ממון",
    "צוואות וירושות",
    "ייפוי כוח מתמשך",
    "ענייני בית הדין הרבני"
  ]
};

export default function ContactSection2() {
  return (
    <section dir="rtl">

      <Helmet>
        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="רז יוסף – משרד עורכי דין"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

        <script type="application/ld+json">
          {JSON.stringify(legalServiceSchema)}
        </script>
      </Helmet>

      <div
        className="ContactSection2-page"
        style={{ position: "relative" }}
      >
        <div
          className="ContactSection2-hero"
          style={{ position: "relative" }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              zIndex: 5,
              padding: "20px"
            }}
          >
            <h1
              style={{
                margin: 0,
                color: "#ffffff",
                fontSize: "clamp(32px, 6vw, 62px)",
                fontWeight: 900,
                lineHeight: 1.2,
                textShadow: "0 4px 15px rgba(0,0,0,0.85)",
                letterSpacing: "1px",
                direction: "rtl"
              }}
            >
              צרו איתנו קשר
            </h1>
          </div>
        </div>
      </div>

      <ContactSection />

      <MapPage />

    </section>
  );
}
